export const workflowFields = {
    comment: null,
    status: null,
    application: "gaia-cb",
};
